import { Text, useToast } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const DeduplicationLink = ({ personID, DEDUPLICATION, isAdmin }) => {
  const toast = useToast();

  const handleClick = (e) => {
    if (!isAdmin) {
      e.preventDefault();
      toast({
        title: "Access Denied",
        description: "Only admins can view the deduplication summary.",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    }
  };

  return (
    <Link to={`/admin/summary/${personID}`} onClick={handleClick}>
      {DEDUPLICATION > 0 ? (
        <Text
          fontSize="xs"
          color="red"
          _hover={{ textDecoration: "underline" }}
          display="flex"
          alignItems="center"
          gap={1}
        >
          Pending Person Deduplication
        </Text>
      ) : (
        <Text
          fontSize="xs"
          color="blue"
          _hover={{ textDecoration: "underline" }}
          display="flex"
          alignItems="center"
          gap={1}
        >
          Check Person Deduplication
        </Text>
      )}
    </Link>
  );
};

export default DeduplicationLink;
